import React from "react";
import {
  MdMonitor,
  MdGroups,
  MdQuestionAnswer,
  MdPlayCircleFilled,
} from "react-icons/md";

function StaticData() {
  return (
    <div className="premium-container">
      {/* --- Section 1: Features (Grid of Cards) --- */}
      <section className="features-wrapper">
        <div className="section-header">
          <h4 className="sub-heading">Why Choose Us</h4>
          <h1 className="main-heading">Immersive Learning Experience</h1>
        </div>

        <div className="features-grid">
          {/* Card 1 */}
          <div className="feature-card">
            <div className="icon-box orange-glow">
              <MdMonitor />
            </div>
            <h3>Presentations</h3>
            <p>
              Colorful slides designed to enhance visual grasping and retention
              of complex topics.
            </p>
          </div>

          {/* Card 2 */}
          <div className="feature-card">
            <div className="icon-box purple-glow">
              <MdGroups />
            </div>
            <h3>Group Projects</h3>
            <p>
              Collaborative environments where teams synergize to architect
              innovative solutions.
            </p>
          </div>

          {/* Card 3 */}
          <div className="feature-card">
            <div className="icon-box orange-glow">
              <MdQuestionAnswer />
            </div>
            <h3>Debates</h3>
            <p>
              Cultivating tolerance for divergent views through reasoned
              arguments and rigorous self-examination.
            </p>
          </div>

          {/* Card 4 */}
          <div className="feature-card">
            <div className="icon-box orange-glow">
              <MdPlayCircleFilled />
            </div>
            <h3>Video Library</h3>
            <p>
              A curated collection of inspiring and engaging video content
              accompanying every module.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default StaticData;
